import { SegmentGroup } from "@/design-system/SegmentGroup";
import { useTranslation } from "@/translations";

export function ToggleCalendarButton({
  isWeek,
  onToggleView,
}: {
  isWeek: boolean;
  onToggleView: () => void;
}): React.ReactNode {
  const { t } = useTranslation();

  const items = [
    { label: t("page.bookings.asset-detail.week-view.title"), value: "week" },
    { label: t("page.bookings.asset-detail.month-view.title"), value: "month" },
  ] as const;

  return (
    <SegmentGroup
      items={items}
      value={isWeek ? "week" : "month"}
      width="content"
      onChange={(value) => {
        if ((value === "week") !== isWeek) {
          onToggleView();
        }
      }}
    />
  );
}
